import { Builder, withChildren } from '@builder.io/react';

import HowItWorks from './index';

Builder.registerComponent(HowItWorks, {
  name: 'Catalog How it Works',
  inputs: [
    {
      name: 'image',
      type: 'object',
      subFields: [
        { name: 'alt', type: 'string' },
        { name: 'src', type: 'file', allowedFileTypes: ['jpeg', 'png', 'svg', 'gif'] },
        { name: 'width', type: 'number' },
        { name: 'height', type: 'number' },
        { name: 'srcMobile', type: 'file', allowedFileTypes: ['jpeg', 'png', 'svg', 'gif'] },
        { name: 'heightMobile', type: 'number' },
        { name: 'widthMobile', type: 'number' }
      ]
    }
  ]
});
